export const EMAIL_CODE_SENT_MESSAGE = "We've sent you an email. Please check and enter the code above";

/**
 * The 2FA code the API handed back from /2fa/send-email, or null.
 *
 * The API only includes `code` in that body when it is running as `dev`, so a developer can log
 * in without opening Mailpit. The dev-mode check here is belt and braces: a production build must
 * never surface a code, whatever the API sends.
 */
export const devEmailCode = (responseBody, devMode) => {
  const code = devMode && responseBody && responseBody.code;

  return code ? String(code) : null;
};

/**
 * Toast text shown after requesting a 2FA code by email.
 */
export const emailCodeSentMessage = (responseBody, devMode) => {
  const code = devEmailCode(responseBody, devMode);

  return code ? `${EMAIL_CODE_SENT_MESSAGE} (dev only - your code is ${code})` : EMAIL_CODE_SENT_MESSAGE;
};
